// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sb-6";
export var imgContainer = "_sb-3";
export var menuIcon = "_sb-5";
export var pillWrapper = "_sb-2";
export var pillsContainer = "_sb-1";
export var subscriptionCard = "_sb-0";
export var subscriptionLogo = "_sb-4";